import { observer } from 'mobx-react';
import * as React from 'react';
import DateTimeInput from '../../../../../../../../../../../../../Resource/FormTemplates/Inputs/DateTimeInput';
import WithField from '../../../../../../../../../../../../../Resource/FormTemplates/Inputs/WithField';
import { FormTemplate } from '../../../../../../../../../../../../../Resource/FormTemplates/Types';
import TimeZone from '../../../../../../../../../../TimeZone';

export interface Props {
  timeZone: string;
  template: FormTemplate;
  disabled: boolean;
  setTimezone: (timeZone: string) => void;
  submit: () => void;
}

const handleSubmit =
  (submit: Props['submit']) =>
  (e: React.SyntheticEvent): void => {
    e.preventDefault();
    submit();
  };

const Form: React.FC<Props> = ({ submit, template, timeZone, disabled, setTimezone }) => (
  <form onSubmit={handleSubmit(submit)} tabIndex={0}>
    <div className="flex mt-6">
      <div className="flex">
        <WithField kind="date" name="send_email_date" fields={template.fields}>
          {(field) => <DateTimeInput field={field} disabled={disabled} />}
        </WithField>
        <TimeZone setTimezone={setTimezone} timezone={timeZone} disabled={disabled} />
      </div>
    </div>
    <input type="submit" hidden />
  </form>
);

export default observer(Form);
